import { useMediaQuery } from 'react-responsive';
import { hot } from 'react-hot-loader';
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  FieldBuilder,
  SubmitButton,
  CloseButton,
  HellosignContainer,
} from '../../../components';
import './DetailsPane.scss';

const DetailsPane =
({
  height,
  selectedDocument,
  submitDisabled,
  isOpen,
  isFormLocked,
  isSubmitting,
  userRoles,
  toggle,
  onSubmit,
  errors,
  touched,
  values,
  formFields,
  dirty,
  isHelloSignOpen,
  resetTemplateState,
  editTemplateData,
  getEditTemplateUrl,
  toggleHelloSign,
}) => {
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1224 });
  const [editTemplateSubmitting, setEditTemplateSubmitting] = useState(false);
  const [saveChangesSubmitting, setSaveChangesSubmitting] = useState(false);
  const [helloSignDrawerOpen, setHelloSignDrawerOpen] = useState(false);
  // when in mobile view, the details pane should be closed by default. When in desktop view, it should be open.

  useEffect(() => {
    if (!isDesktopOrLaptop && isOpen) {
      toggle();
    } else if (isDesktopOrLaptop && !isOpen) {
      toggle();
    }
  }, [isDesktopOrLaptop]);

  const toggleHelloSignDrawer = () => {
    setHelloSignDrawerOpen(!helloSignDrawerOpen);
  };

  return (

    <div
      className={`col pt-4 details-pane
            ${isOpen ? ' d-flex flex-column' : ' d-none'}
            ${!isDesktopOrLaptop ? ' position-fixed' : ' pane-width'}`}
      style={{ height: height || 'auto', background: '#ffffff' }}
    >
      <Row>
        <Col sm="10">
          <h5 className="text-muted pt-1 mb-4"><FormattedMessage id="DETAILS" /></h5>
        </Col>
        <Col sm="2">
          <CloseButton
            onClick={(e) => {
              e.preventDefault();
              toggle();
            }}
          />
        </Col>
      </Row>
      <FieldBuilder
        formFieldData={formFields}
        userRoles={userRoles}
        errors={errors}
        touched={touched}
        locked={isFormLocked}
        isSubmitting={isSubmitting}
      />
      {selectedDocument.isHelloSignTemplate ?
        <Fragment>
          <Row>
            <Col>
              <SubmitButton
                onSubmit={() => {
                  toggleHelloSign();
                  if (dirty) onSubmit(values);
                  toggleHelloSignDrawer();
                  getEditTemplateUrl(selectedDocument.id);
                  setEditTemplateSubmitting(true);
                }}
                defaultLabel="EDIT_TEMPLATE"
                submittingLabel="OPENING_EDITOR"
                disabled={
                  isSubmitting ||
                  isHelloSignOpen
                }
                submitting={editTemplateSubmitting && isSubmitting}
                wideButton
              />
            </Col>
          </Row>
        </Fragment>
        : null
      }
      <Row className="flex-grow-1">
        <Col className="d-flex align-items-end pb-3">
          {!isFormLocked ?
            <SubmitButton
              onSubmit={() => {
                setSaveChangesSubmitting(true);
                onSubmit(values);
              }}
              defaultLabel="SAVE_CHANGES"
              submittingLabel="SAVING_CHANGES"
              disabled={
                    submitDisabled ||
                    isSubmitting ||
                    (errors.title === 'PLEASE_SPECIFY_A_TITLE') ||
                    !dirty
                  }
              submitting={saveChangesSubmitting && isSubmitting}
            />
              : null
          }
        </Col>
      </Row>
      {helloSignDrawerOpen ?
        <HellosignContainer
          toggleHelloSignDrawer={toggleHelloSignDrawer}
          helloSignDrawerOpen={helloSignDrawerOpen}
          resetTemplateState={resetTemplateState}
          templateData={{ url: editTemplateData.url, clientId: editTemplateData.clientId }}
          documentTitle={values.title}
        />
        : null
      }
    </div>
  );
};

DetailsPane.defaultProps = {
  height: undefined,
  submitDisabled: false,
  isFormLocked: false,
  isSubmitting: false,
  isOpen: false,
  dirty: false,
  selectedDocument: {},
  isHelloSignOpen: false,
  toggleHelloSign: undefined,
};

DetailsPane.propTypes = {
  height: PropTypes.string,
  submitDisabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  isFormLocked: PropTypes.bool,
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  formFields: PropTypes.arrayOf(PropTypes.any).isRequired,
  isSubmitting: PropTypes.bool,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggle: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isHelloSignOpen: PropTypes.bool,
  toggleHelloSign: PropTypes.func,
  editTemplateData: PropTypes.shape({
    url: PropTypes.string,
    clientId: PropTypes.string,
  }).isRequired,
  resetTemplateState: PropTypes.func.isRequired,
  selectedDocument: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    filename: PropTypes.string,
    category: PropTypes.string,
    uploadDate: PropTypes.string,
    extension: PropTypes.string,
    isPublishedToEmployee: PropTypes.bool,
    companyId: PropTypes.number,
    companyName: PropTypes.string,
    employeeId: PropTypes.number,
    employeeName: PropTypes.string,
    isOnboarding: PropTypes.bool,
    uploadedBy: PropTypes.string,
    isLegacyDocument: PropTypes.bool,
    isEsignatureDocument: PropTypes.bool,
    isHelloSignTemplate: PropTypes.bool,
    isPrivate: PropTypes.bool,
    status: PropTypes.shape({
      name: PropTypes.string,
      priority: PropTypes.number,
      stepNumber: PropTypes.number,
      isProcessing: PropTypes.bool,
    }),
  }),
  dirty: PropTypes.bool,
  getEditTemplateUrl: PropTypes.func.isRequired,
};

export default (hot(module)(DetailsPane));



// WEBPACK FOOTER //
// ./src/containers/EditDocument/DetailsPane/DetailsPane.jsx